import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/vistas";

const getStockProductos = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}/stock`);
  return response.data;
};

const getAlertasStock = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}/alertas_stock`);
  return response.data;
};

const getMovimientosProductos = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}/movimientos_productos`);
  return response.data;
};

const getResumenProyectos = async () => {
  const response = await axios.get(`${baseUrl}${endpoint}/resumen_proyectos`);
  return response.data;
};

export {
  getStockProductos,
  getAlertasStock,
  getMovimientosProductos,
  getResumenProyectos
};